import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export class PdpRespNotificationsWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEnabled: false,
        };

        this.type = this.props.type;
    }

    componentWillReceiveProps(nextProps) {
        const { callouts } = nextProps;

        this.setState({ isEnabled: !!callouts[this.type] });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.isEnabled !== nextState.isEnabled;
    }

    render() {
        const { isEnabled } = this.state;
        const { callouts = {} } = this.props;
        const { [this.type]: callout } = callouts;

        return callout ? this.props.children({ isEnabled }) : null;
    }
}

PdpRespNotificationsWrapper.propTypes = {
    type: PropTypes.string.isRequired,
    callouts: PropTypes.object,
    children: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
    const callouts = get(state, 'pdpRespNotificationsReducer.callouts') || {};
    return { callouts };
};

export default connect(mapStateToProps)(PdpRespNotificationsWrapper);
